import { Request } from '../../Servidor/Request';

export class RequestPasswordResetRequest {
    private email: string;

    constructor(email: string) {
        this.email = email; 
    }

    /** Getter email */
    public getEmail(): string {
        return this.email;
    }
}

export class RequestPasswordResetInteractor {
    public fetchSave(request: RequestPasswordResetRequest): Promise<boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("login/email-redefinir-senha", request).then((rs) => {
                if (!rs) {
                    return rej({ Mensagem: "Erro ao conectar" });
                }

                const sucesso = rs.Status === "Sucesso";
                res(sucesso);
            }, (e) => {
                rej(e)
            }
            );
        });
    }
}
